import { render, staticRenderFns } from "./DirectorVariableSalaryModal.vue?vue&type=template&id=4b393973&scoped=true&"
import script from "./DirectorVariableSalaryModal.vue?vue&type=script&lang=ts&"
export * from "./DirectorVariableSalaryModal.vue?vue&type=script&lang=ts&"
import style0 from "./DirectorVariableSalaryModal.vue?vue&type=style&index=0&id=4b393973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b393973",
  null
  
)

export default component.exports